import * as React from 'react';

// @ld
// @custom
import useUser from 'hooks/use-user';
import useGetItem from 'api/utils/use-get-item';

import { IProfileRead, PROFILES } from '@ld/utils';

const ProfileContext = React.createContext<{
  isError: boolean;
  profileId: string;
  profile?: IProfileRead;
  refetch: () => void;
  setProfileId: (profileId?: string) => void;
}>({ profileId: '', isError: false, setProfileId: () => null, refetch: () => null });

export const ProfileProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useUser();
  const [profileId, setProfileId] = React.useState<string>();

  const {
    data: profile,
    isError,
    refetch
  } = useGetItem<IProfileRead>({
    collection: PROFILES,
    id: profileId,
    enabled: !!profileId
  });

  React.useEffect(() => {
    if (!profileId && user?.primaryProfileId) {
      setProfileId(user.primaryProfileId);
    }
  }, [profileId]);

  return (
    <ProfileContext.Provider
      value={{
        isError,
        profile,
        refetch,
        setProfileId,
        profileId: profileId || ''
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

ProfileContext.displayName = 'ProfileContext';

export default ProfileContext;
